import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './editor-base.scss';
import { TS_EditableContent } from '@nu-art/thunderstorm-frontend/components/TS_EditableContent/TS_EditableContent';
export class Component_BasePermissionItemEditor extends TS_EditableContent {
    deriveStateFromProps(nextProps, state) {
        super.deriveStateFromProps(nextProps, state);
        state.editable.setOnChanged(async () => this.forceUpdate());
        return state;
    }
    render() {
        if (!this.state.editable)
            return '';
        const editable = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'item-editor__header', children: editable.item._id ? this.props.displayResolver?.(editable.item) : `New ${this.props.module.dbDef.entityName}` }), _jsx(LL_V_L, { className: 'item-editor__main', children: this.editorContent() })] });
    }
}
//# sourceMappingURL=editor-base.js.map